/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
type ModifyListenersParams = {
	element: HTMLElement | null;
	operationName: 'add' | 'remove';
	eventMap: Record<string, EventListener>;
};

export function modifyListeners(params: ModifyListenersParams): void {
	const { element, operationName, eventMap } = params;
	const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';

	if (element) {
		Object.keys(eventMap).forEach((eventName) =>
			element[functionName](eventName, eventMap[eventName]),
		);
	}
}
